import { List as ListIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

import type { UserList } from '@/api/types'
import { LockBadge } from '@/components/ui/LockBadge'
import { useI18n } from '@/i18n'
import { useFormat } from '@/lib/format'

/** 列表的一行：图块 + 名字 + 描述 + 人数。 */
export function ListRow({ list }: { list: UserList }) {
  const { tp } = useI18n()
  const { compactCount } = useFormat()
  return (
    <Link
      to={`/lists/${list.id}`}
      className="flex gap-3 border-b border-line px-4 py-3 transition-colors hover:bg-surface-hover"
    >
      <span
        aria-hidden
        className="flex size-12 shrink-0 items-center justify-center px-corners [--px-step:3px] bg-brand-subtle text-brand-ink"
      >
        <ListIcon className="size-6" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-1 font-bold">
          <span className="truncate">{list.name}</span>
          {list.is_private && <LockBadge />}
        </span>
        {list.description && (
          <span className="block truncate text-[15px] text-ink-muted">{list.description}</span>
        )}
        <span className="block text-[13px] text-ink-muted">
          {tp('lists.memberCount', list.member_count, { count: compactCount(list.member_count) })}
          {!list.viewer.is_owner && ` · @${list.owner.username}`}
        </span>
      </span>
    </Link>
  )
}
